// libs
import React, { memo } from 'react';

//components
import Radio from '@nykaa/ui-components/Radio';
import ColorImage from 'shared/components/Filter/components/ColorImage';

//styles
import { List, OptionName, OptionCount, ValueContainer } from './styles';

// defs
import { ALIGNMENT_TYPE, RADIO_TYPE, Value } from 'shared/components/Filter/types';

interface FilterRadioProps {
  value: Value;
  onFilterSelection: (filterId: string) => VoidFunction;
  isSelected: boolean;
  isHighlighted?: boolean;
  alignmentType?: ALIGNMENT_TYPE;
  isTickIcon?: boolean;
  className?: string;
}

function FilterRadio({
  value,
  onFilterSelection,
  isSelected,
  isHighlighted = true,
  alignmentType = ALIGNMENT_TYPE.RIGHT,
  isTickIcon = false,
  className = '',
}: FilterRadioProps) {
  const EMPTY_FUNC = () => {};
  const { id, name, productCount } = value;

  const onClickHandler: React.MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onFilterSelection(id);
  };

  return (
    <List
      isLeftAligned={alignmentType === ALIGNMENT_TYPE.LEFT}
      onClick={onClickHandler}
      isDisabled={!isHighlighted}
      className={className}
      isSelected={isSelected}
    >
      <Radio
        checked={isSelected}
        onClick={EMPTY_FUNC}
        onChange={EMPTY_FUNC}
        type={isTickIcon ? RADIO_TYPE.LIST : RADIO_TYPE.DEFAULT}
      />
      <ValueContainer isLeftAligned={alignmentType === ALIGNMENT_TYPE.LEFT}>
        <ColorImage value={value} />
        <OptionName title={name} isSelected={isSelected}>
          {name}
        </OptionName>
        {Number(value?.productCount) > 0 && <OptionCount>{productCount}</OptionCount>}
      </ValueContainer>
    </List>
  );
}

export default memo(FilterRadio);
